// 치과 「예약」 노출 공용 훅 — 파일럿 치과 한정 (2026-10-11, 계획 docs/계획_케어앱_예약대기_2026-10-11.md §1·W2)
//
// 노출 = isCareBookingOn(config/features.careBooking strict + 환자관리 열림)  AND  서버 getClinicBookingSettings().available === true
//   (available = 플래그 && 비공개 파일럿 목록 && 위탁 확인 판 — 서버 판정과 같은 1비트. 웹은 파일럿 목록을 직접 읽지 않는다)
// fail-closed: 응답 전·조회 실패·서버 미배포·치과 아닌 계정 = 숨김. 플래그 OFF면 서버 호출 0(기존 화면 회귀 0).
// 호출 횟수: getClinicBookingSettingsShared 가 30초 공유 캐시 + 진행 중 Promise 재사용 — 메뉴·화면·환자 상세가 같이 있어도 네트워크 1회.
// 반환 { on, loading, flagOn, settings } — 메뉴·버튼은 on 만 본다.
import { useEffect, useState } from 'react';
import { getFeatures, isCareBookingOn } from './features';
import { getClinicBookingSettingsShared, subscribeClinicBookingSettings } from '../services/bookingApi';
import { isClinicAccount } from './useRoadmapPilot';

export function useBookingAvailable(user) {
    const [state, setState] = useState({ on: false, loading: true, flagOn: false, settings: null });
    const uid = user?.uid || '';
    const email = user?.email || '';
    const isClinic = isClinicAccount(user);

    useEffect(() => {
        let alive = true;
        if (!uid || !isClinic) { setState({ on: false, loading: false, flagOn: false, settings: null }); return () => { alive = false; }; }

        const run = async () => {
            let flagOn = false;
            try { flagOn = isCareBookingOn(await getFeatures(), user, email); }
            catch (e) { console.error('[예약 게이트] 플래그 조회 실패:', e?.code || e?.message || e); }
            if (!alive) return;
            if (!flagOn) { setState({ on: false, loading: false, flagOn: false, settings: null }); return; }
            let settings = null;
            try { settings = await getClinicBookingSettingsShared(); }
            catch (e) { console.error('[예약 게이트] 설정 조회 실패(숨김 처리):', e?.code || e?.details?.code || e?.message || e); }
            if (!alive) return;
            setState({ on: settings?.available === true, loading: false, flagOn: true, settings });
        };
        run();
        // 설정 저장 직후 재판정
        const unsub = subscribeClinicBookingSettings(() => { if (alive) run(); });
        return () => { alive = false; unsub(); };
    }, [uid, email, isClinic]); // eslint-disable-line react-hooks/exhaustive-deps

    return state;
}

export default useBookingAvailable;
